import type { EventTypes } from '@racemap/sdk/schema/events';
import type { EventState, PoiType, StarterType, TrackType } from 'src/lib/player/store';

export enum SidebarSection {
  FAVORITE = 'FAVORITE',
  EVENTS = 'EVENTS',
  POI = 'POI',
  TRACK = 'TRACK',
  STARTERS = 'STARTERS',
}

export enum SidebarItemType {
  HEADER = 'HEADER',
  EVENT = 'EVENT',
  STARTER = 'STARTER',
  STARTER_GROUP = 'STARTER_GROUP',
  STARTER_FILTER = 'STARTER_FILTER',
  STARTER_SORT = 'STARTER_SORT',
  POI = 'POI',
  TRACK = 'TRACK',
}

export type SidebarItem =
  | {
      type: SidebarItemType.HEADER;
      label:
        | SidebarSection.FAVORITE
        | SidebarSection.POI
        | SidebarSection.TRACK
        | SidebarSection.STARTERS;
    }
  | {
      type: SidebarItemType.HEADER;
      label: SidebarSection.EVENTS;
      eventType: EventTypes;
    }
  | { type: SidebarItemType.EVENT; event: EventState }
  | { type: SidebarItemType.STARTER; starter: StarterType; isFavorite?: boolean; group?: string }
  | { type: SidebarItemType.STARTER_GROUP; tagKey: string; tagValue: string }
  | { type: SidebarItemType.STARTER_FILTER; itemCount: number }
  | { type: SidebarItemType.STARTER_SORT }
  | { type: SidebarItemType.POI; poi: PoiType; isFavorite?: boolean }
  | { type: SidebarItemType.TRACK; track: TrackType; isFavorite?: boolean };

export enum SortKey {
  START_NUMBER = 'START_NUMBER',
  NAME = 'NAME',
  OFFSET = 'OFFSET',
}

export type SortDirection = 'ASC' | 'DESC';

export type StarterSorting = [SortKey, SortDirection];

export interface ItemStyle {
  position: 'absolute' | 'sticky';
  top?: number;
  left: number;
  width: string | number;
  height?: number;
  zIndex?: number;
}
